module.exports = "pegasus/assets/themelp1/small/12.png";